import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { APIResponse } from '../variables/api-response';

export interface ContactSupportRequest {
  companycode: string;
  Comment: string;
  EmailSendTo: number; // 1 = TaxDocEmail, 2 = TechSupportEmail
}

@Injectable({
  providedIn: 'root'
})
export class ContactSupportService {
  baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.API_URL;
  }

  sendContactSupport(request: ContactSupportRequest) {
    return this.http.post<APIResponse>(this.baseUrl + 'api/contact-support', request);
  }
}
